(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/shared-charity/assets/tracking.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/shared-charity/assets/tracking.js');
"use strict";

const trackEvent = svs.components.analytics.trackEvent;
setGlobal('svs.lyckoplatsen.shared_charity', {
  trackVGHOPicked: (isPreChosen, name) => {
    trackEvent({
      category: 'Lyckoplatsen',
      action: isPreChosen ? 'God sak - förvald' : 'God sak',
      opt_label: name
    });
  },
  trackVGHOChange: (isSub, name) => {
    trackEvent({
      category: 'Lyckoplatsen',
      action: isSub ? 'God sak - Byt organisation - Prenumeration' : 'God sak - Byt organisation',
      opt_label: name
    });
  }
});

 })(window);